import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ActionPlanService } from 'src/app/core/services/action-plan.service';
import { CommonService } from 'src/app/core/services/common.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { GlobalConstants } from 'src/app/shared/constants/global-constants';
import { ActionItemDetailComponent } from '../action-item-detail/action-item-detail.component';
import { HistoricalActionItemsComponent } from '../historical-action-items/historical-action-items.component';
import { PendingActionItemsComponent } from '../pending-action-items/pending-action-items.component';
import { RejectedActionItemsComponent } from '../rejected-action-items/rejected-action-items.component';

@Component({
  selector: 'app-action-items',
  templateUrl: './action-items.component.html',
  styleUrls: ['./action-items.component.css']
})
export class ActionItemsComponent implements OnInit {
  isArabic!: boolean;
  @Input() actionItemsList: any;
  @Input() ifPendingActionItem!: boolean;
  @Input() ifRejectedActionItem!: boolean;
  @Input() ifHistoricalActionItem!: boolean;
  actionItem!: any;
  subscription!: Subscription;
  allActionPlans: any;
  pendingCount: any;
  rejectedCount: any;
  userData: any;

  constructor(private route: Router, private storageService: StorageService,
    private actionPlanService: ActionPlanService, private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.userData = this.storageService.getSessionStorageData('userDetails');
    this.generateActionPlansCount();
    this.actionPlanService.isActionPlanCountChange$.subscribe((isChange: any) => {
      if (isChange) {
        this.generateActionPlansCount();
      }
    })

  }

  generateActionPlansCount() {
    const rqstBody = {
      assessmentUnitGuid: this.userData?.assessmentUnitValue,
    };

    this.actionPlanService.getAllActionPlans(rqstBody).subscribe((res: any) => {
      if (res?.data) {
        let decryptedData = this.commonService.decryptUsingAES256(res?.data);
        let resp = JSON.parse(JSON.stringify(decryptedData));
        if (resp.actionPlans.length > 0) {
          this.allActionPlans = resp.actionPlans;
          this.pendingCount = this.allActionPlans.filter((item: any) =>
          (item.actionPlanStatus == GlobalConstants.ACTION_PLAN_ITEM_STATUSES.PENDING.name ||
            item.actionPlanStatus == GlobalConstants.ACTION_PLAN_ITEM_STATUSES.IN_PROGRESS.name || 
          item.actionPlanStatus == GlobalConstants.ACTION_PLAN_ITEM_STATUSES.WARNING1.name ||
        item.actionPlanStatus == GlobalConstants.ACTION_PLAN_ITEM_STATUSES.WARNING2.name|| 
      item.actionPlanStatus == GlobalConstants.ACTION_PLAN_ITEM_STATUSES.WARNING3.name ||
      item.actionPlanStatus == GlobalConstants.ACTION_PLAN_ITEM_STATUSES.SUSPENSION.name ||
      item.actionPlanStatus == GlobalConstants.ACTION_PLAN_ITEM_STATUSES.STRIKEOFF.name
    )
          ).length;
          this.rejectedCount = this.allActionPlans.filter((item: any) => item.actionPlanStatus == GlobalConstants.ACTION_PLAN_ITEM_STATUSES.REJECTED.name).length;
        }
      }
    }), (error: any) => {
    }
  }

  goToActionItem() {
    if (this.ifPendingActionItem) {
      this.route.navigate(['executor-dashboard/action-items/pending/details'], { queryParams: {} });
    }
    else if (this.ifRejectedActionItem) {
      this.route.navigate(['executor-dashboard/action-items/rejected/details'], { queryParams: {} });
    }
    // else if (this.ifHistoricalActionItem) {
    //   this.route.navigate(['executor-dashboard/action-items/historical/details'], { queryParams: {} });
    // }
  }

  subscribeToEmitter(componentRef: any) {
    if (!(componentRef instanceof PendingActionItemsComponent ||
      componentRef instanceof RejectedActionItemsComponent ||
      componentRef instanceof HistoricalActionItemsComponent ||
      componentRef instanceof ActionItemDetailComponent
    )) {
      return;
    }
    const child: any = componentRef;
    this.subscription = child.actionPlanEvent?.subscribe((data: any) => {
      if (data) {
        this.actionItem = JSON.parse(data);
        this.storageService.setSessionStorageData('selectedPlan', this.actionItem);

        if (componentRef instanceof HistoricalActionItemsComponent) {
          this.route.navigate(['executor-dashboard/action-items/historical/details'], { queryParams: {} });
        }
      }

    });
  }

  onListItemClick(selectedItemIdx: number) {
    this.actionItemsList.forEach((v: any, i: any) => {
      if (i === selectedItemIdx) {
        v.isActive = true;
      } else {
        v.isActive = false;
      }
    });
    this.ifPendingActionItem = this.actionItemsList[selectedItemIdx]?.link === 'action-items/pending';
    this.ifRejectedActionItem = this.actionItemsList[selectedItemIdx]?.link === 'action-items/rejected';
    this.ifHistoricalActionItem = this.actionItemsList[selectedItemIdx]?.link === 'action-items/historical';
    if (this.actionItemsList[selectedItemIdx].link !== '') {
      let path = 'executor-dashboard/' + this.actionItemsList[selectedItemIdx].link;
      this.route.navigate([path]);
      this.generateActionPlansCount();
    }

  }

}
